export default "__VITE_ASSET__BV7KwJcs__"